<template lang="pug">
  div.section-data(:style="_minHeight")
    div.title.d-flex.justify-content-between
        div.text
          slot(name="title")
            #slot-title
            h3.font-blue {{title}}
            p.font-gray-dark {{description}}
        div.tools
          slot(name="tools")
          #slot-tools
    div.data
      div.is-loading(v-if="loading")
        vue-simple-spinner(size="medium", message="Obteniendo información...", line-fg-color="#244076")
      div.is-empty(v-else-if="isEmpty ||!hasContentSlot")
        img(src="@/assets/empty-data-icon.jpg", height="80")
        p.font-gray-dark No se ha encontrado información para mostrar
      div(v-else)
        #slot-content
        div.content
          slot(name="content")
</template>
<script>
  /**
   * Este componente puede ser modificado mediante slots
   * @slots
   * title : titulo de la tarjeta
   * tools : agregar bottones u opciones en la parte derecha de titulo
   * content : contenido de la tarjeta
   * @props
   * isEmpty : contenido en blanco para la tarjeta
   * */
  export default {
    props: {
      isEmpty: {
        type: Boolean,
        default: false
      },
      loading: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'Titulo de tarjeta'
      },
      description: {
        type: String,
        default: 'Escribe una descripción para esta sección'
      },
      minHeight: {
        type: Number,
        default: 400
      }

    },
    computed: {
      hasContentSlot(){
        return !!this.$slots.content
      },
      _minHeight() {
        return `min-height: ${this.minHeight}px`;
      }
    },
  }
</script>
<style lang="scss">
  .section {
    &-data {
      background: #fff!important;
      -webkit-box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;
      box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important;
      border-radius: .25rem!important;
      .title {
        padding: 15px 0 0 15px;
        border-bottom: 1px solid #EEEEEE;
      }
      .data {
        .is-empty, .is-loading {
          padding: 45px;
          text-align: center;
          justify-content: center;
          align-content: center;
          img {
            opacity: .5;
          }
        }
    }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/TheSectionContent.vue